<!--component for listing phrases so they can be editable on phrases page-->
<template>
  <div class="flex align-center py1 border-bottom border-gray-4">
    <div class="col-3 flex-none">
      <div class="flex input-addon mr3" @click="editPhrase">
        <input v-model="hashtag" type="text" class="col-12 semibold order-1" :placeholder="'fraasi' + (!profile.admin ? '' : ' tai ##jaettu-fraasi')" :readonly="!showButtons">
        <div class="flex-none semibold">#</div>
      </div>
      <div class="flex flex-none error" v-if="hasError">Sana on jo käytössä</div>
    </div>
    <div class="flex col-9">
      <div class="flex-auto mr1">
        <div
          v-if="!showButtons"
          class="phrase-input left-align mr1"
          @click="editPhrase"
        >{{value}}</div>
        <textarea-autosize
          v-else
          class="phrase-input"
          ref="phraseInputTextArea"
          :disabled="!showButtons"
          :min-height="37"
          :max-height="115"
          rows="1"
          placeholder="Korvaava teksti"
          v-model="value"
        />
      </div>

      <div class="flex-none">
        <div v-if="!showButtons">
          <v-button variant="icon" @click="editPhrase" class="mr1">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <g stroke="#00A1D4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6.657 20.172L1 23l2.83-5.657L20 1.173A2 2 0 0 1 22.83 4L6.656 20.172zM21.415 5.415l-2.829-2.83M6.657 20.172L3.83 17.343"/>
              </g>
            </svg>
          </v-button>
        </div>
        <div v-else>
          <v-button variant="icon" @click="savePhrase" class="mr1">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <g stroke="#00A1D4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 8.5l-7.5 7L7 13"/>
                <path d="M23.5 12c0 6.352-5.15 11.5-11.5 11.5C5.647 23.5.5 18.352.5 12S5.647.5 12 .5C18.35.5 23.5 5.648 23.5 12z"/>
              </g>
            </svg>
          </v-button>
          <v-button variant="icon" @click="deletePhrase">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <g stroke="#F00020" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3.5 23.5h16v-20h-16zM7.5 3.5h8v-3h-8zM1 3.5h22M7.5 7v12M11.5 7v12M15.5 7v12"/>
              </g>
            </svg>
          </v-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex"
import Button from '@/components/Button.vue'
import TextareaAutosize from '@/components/TextareaAutosize.vue'

export default {
  name: 'PhraseEditItem',
  data () {
    return {
      hasError: false,
      originalPhrase: this.phrase,
      hashtag: (this.phrase.company ? '#' : '') + this.phrase.hashtag,
      value: this.phrase.phrase,
      showButtons: false,
    };
  },
  props: {
    phrase: {},
  },
  components: { TextareaAutosize, 'v-button': Button },
  computed: {
    ...mapGetters({
        profile: 'profile',
        phrases: 'allPhrases',
    }),
  },
  mounted: function() {
  },
  methods: {
    async savePhrase() {
      if (!this.hashtag.length || !this.value.length) {
        return;
      }

      const hashtag = (this.profile.admin && this.hashtag.startsWith('#') ? '#' : '') + this.hashtag.replace(/^#+/, '');

      if (hashtag !== this.originalPhrase.hashtag && this.phrases.some(x => x.hashtag === hashtag)) {
        this.hasError = true;
        return;
      }

      const newPhrase = {
        hashtag: this.hashtag,
        phrase: this.value
      }
      await this.$store.dispatch('deletePhrase', this.phrase);
      await this.$store.dispatch('savePhrase', newPhrase);
      this.hasError = false;
      this.showButtons = false;
    },
    editPhrase() {
      this.showButtons = true;
    },
    deletePhrase() {
      this.$store.dispatch('deletePhrase', this.phrase);
      this.showButtons = false;
    },
  }
}

</script>

<style scoped>
  .input-addon > div {
    padding: var(--space-1);
    padding-right: 0;
    color: var(--dark-blue);
    font-size: var(--h5);
    border: 1px solid var(--gray-3);
    border-right: 0;
    margin-right: -1px;
    z-index: 1;
    background-color: #fff;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .phrase-input {
    flex: auto;
    margin: 0;
    padding: .50em;
    font-size: var(--h5);
    resize: none;
    background-color: transparent;
    width: 100%;
  }

  div.phrase-input {
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    max-height: 8.2em;
    line-height: 1.4em;
    white-space: pre;
    border-style: solid;
    border-color: var(--gray-3);
    border-width: 1px;
    border-radius: 3px;
  }

  .input-addon > input {
    padding-left: 0;
  }

  .input-addon > input:focus ~ div {
    border-color: var(--dark-blue)
  }

  .error {
    color: red;
    font-size: var(--h5);
    font-weight: bold;
  }
</style>
